import * as React from 'react'

import RadioButton from '../../atoms/RadioButton/RadioButton'
import type { InputAttrs } from '../../types'
import FormInput from '../FormInput/FormInput'
import { Container, RadioButtonContainer } from './RadioGroup.styles'

export interface RadioGroupProps extends InputAttrs<unknown> {
  options: string[],
  label?: string,
}

const RadioGroup: React.FunctionComponent<RadioGroupProps> = ({
  options,
  value,
  isValid,
  onChange,
  label,
  validationMessage,
}) => {
  const handleChange = (option: string) => {
    onChange(option)
  }

  return (
    <FormInput title={label} isValid={isValid} validationMessage={validationMessage}>
      <Container>
        {options.map(option => (
          <RadioButtonContainer key={option} onClick={() => handleChange(option)} checked={option === value}>
            <RadioButton
              id={option}
              label={option}
              name={option}
              checked={option === value}
              onChange={() => handleChange(option)}
            />
          </RadioButtonContainer>
        )
        )}
      </Container>
    </ FormInput>
  )
}

export default RadioGroup
